import { api } from './api';
import { SupportTicket, SupportTicketListResponse, ChatMessage } from '../types/Support';

// GET all support tickets (paginated & filtered)
export const listSupportTickets = (
    page: number = 1,
    limit: number = 20,
    filters?: { status?: string; issueType?: string; rideId?: number }
) => {
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('limit', limit.toString());
    if (filters?.status) params.append('status', filters.status);
    if (filters?.issueType) params.append('issueType', filters.issueType);
    if (filters?.rideId) params.append('rideId', filters.rideId.toString());

    return api.get<SupportTicketListResponse>(`/admin/support-tickets?${params.toString()}`);
};

// GET single ticket details
export const getSupportTicket = (id: number) => {
    return api.get<SupportTicket>(`/admin/support-ticket/${id}`);
};

// UPDATE ticket (status/assignee)
export const updateSupportTicket = (id: number, data: Partial<SupportTicket>) => {
    return api.patch<SupportTicket>(`/admin/support-ticket/${id}`, data);
};

// GET chat history for a ticket
export const getTicketMessages = (id: number) => {
    return api.get<ChatMessage[]>(`/admin/support-ticket/${id}/messages`);
};

// POST a new message (reply)
export const sendTicketMessage = (id: number, content: string) => {
    return api.post<ChatMessage>(`/admin/support-ticket/${id}/message`, { content });
};